// extracted by mini-css-extract-plugin
module.exports = {"popup":"Popup-module--popup--2UNHv","popupCloseBtn":"Popup-module--popup-close-btn--2Mthm","popupImg":"Popup-module--popup-img--20C_6"};